export default `
  query listGitHubRepos($login: String!, $pageUrl: String) {
    listGitHubRepos(login: $login, pageUrl: $pageUrl) {
      success
      errorText
      resData {
        repos {
          id
          name
          full_name
          description
          html_url
          private
          language
          owner {
            login
            avatar_url
          }
        }
        nextPageUrl
      }
    }
  }
`
